import type { ReactNode } from 'react'
import { cx } from '../cx'
import s from './Heading.module.css'

/** A title. Level 1 is the page's (Screen draws it), 2 a section or card, 3 a group inside one. */
export function Heading(props: { children: ReactNode; level?: 1 | 2 | 3; id?: string }) {
  const level = props.level ?? 2
  const Tag = `h${level}` as const
  return (
    <Tag id={props.id} className={cx(s.heading, s[`l${level}`])}>
      {props.children}
    </Tag>
  )
}
